import { render, staticRenderFns } from "./ModalEditLocationMailSettings.vue?vue&type=template&id=c2aae972"
import script from "./ModalEditLocationMailSettings.vue?vue&type=script&lang=js"
export * from "./ModalEditLocationMailSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports